module.exports = __webpack_public_path__ + "img/masuyama.c20afa3e.jpg";